import { submitCheckoutPaymentAction } from 'redux/actions/checkoutActions';
import { generateSimpleRequestReducer } from 'redux/utils/requestWithoutData';

export default generateSimpleRequestReducer(submitCheckoutPaymentAction);
